import { createFileRoute } from '@tanstack/react-router'
import { PatientEditorPage } from '@/features/patients/editor'

export const Route = createFileRoute('/patients_/$patientId/edit')({
  component: RouteComponent,
})

function RouteComponent() {
  const { patientId } = Route.useParams()
  return <PatientEditorPage patientId={patientId} />
}
